export default function valueInLocalCurrency(value, exchangeRate) {
    if (value) {
        return value * exchangeRate;
    }
}